import React from "../../_snowpack/pkg/react.js";
import {Spinner} from "../../_snowpack/pkg/@patternfly/react-core.js";
export const KeycloakSpinner = () => /* @__PURE__ */ React.createElement("div", {
  className: "pf-u-text-align-center"
}, /* @__PURE__ */ React.createElement(Spinner, null));
